import { useState, useEffect } from 'react';
import { useLanguage } from '../contexts/LanguageContext';
import { X, Download } from '@phosphor-icons/react';

export default function PWAInstallPrompt() {
  const { t } = useLanguage();
  const [deferredPrompt, setDeferredPrompt] = useState(null);
  const [showPrompt, setShowPrompt] = useState(false);

  useEffect(() => {
    const handler = (e) => {
      e.preventDefault();
      setDeferredPrompt(e);
      
      // Show prompt if not dismissed before
      const dismissed = localStorage.getItem('pwa_prompt_dismissed');
      if (!dismissed) {
        setTimeout(() => setShowPrompt(true), 3000);
      }
    };

    window.addEventListener('beforeinstallprompt', handler);

    // Check if already installed
    if (window.matchMedia('(display-mode: standalone)').matches) {
      setShowPrompt(false);
    }

    return () => window.removeEventListener('beforeinstallprompt', handler);
  }, []);

  const handleInstall = async () => {
    if (!deferredPrompt) return;
    
    deferredPrompt.prompt();
    const { outcome } = await deferredPrompt.userChoice;
    
    if (outcome === 'accepted') {
      setShowPrompt(false);
    }
    setDeferredPrompt(null);
  };

  const handleDismiss = () => {
    setShowPrompt(false);
    localStorage.setItem('pwa_prompt_dismissed', 'true');
  };

  if (!showPrompt) return null;

  return (
    <div className="pwa-prompt animate-slide-in">
      <button 
        onClick={handleDismiss}
        className="absolute top-2 right-2 p-1 hover:bg-gray-100 rounded"
      >
        <X size={18} className="text-gray-500" />
      </button>
      
      <div className="flex items-start gap-3">
        <div className="p-2 ship-gradient rounded-lg">
          <Download size={24} className="text-white" />
        </div>
        <div className="flex-1">
          <h3 className="font-bold text-gray-900">{t('installApp')}</h3>
          <p className="text-sm text-gray-600 mt-1">{t('installDesc')}</p>
        </div>
      </div>
      
      <div className="flex gap-2 mt-4">
        <button
          onClick={handleDismiss}
          className="flex-1 px-4 py-2 text-sm text-gray-600 hover:bg-gray-100 rounded-lg"
        >
          {t('later')}
        </button>
        <button
          onClick={handleInstall}
          className="flex-1 px-4 py-2 text-sm text-white ship-gradient rounded-lg font-medium"
        >
          {t('install')}
        </button>
      </div>
    </div>
  );
}
